export default {
  overrideRequest: function (axiosConfig) {

  },
  validategeolocation: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  validategeolocationcountry: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  completegeolocattempt: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  initgeolocattempt: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  }
}



// WEBPACK FOOTER //
// ./src/library/rpcService/api/services/Geolocation.js